import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getRestrictionSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/utils/restrictionsSubheader.utils';
import { useMealCreditItemRestrictions } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ItemRestrictionsRule/hooks/useMealCreditItemRestrictions';

export interface UseGetItemRestrictionsSubheaderReturn {
  subheader: string;
}

export const useGetItemRestrictionsSubheader =
  (): UseGetItemRestrictionsSubheaderReturn => {
    const { isLoading, itemRestrictionsMeta } = useMealCreditItemRestrictions();
    const { watch } = useFormContext<IMealCreditFormFields>();
    const itemRestrictionFormSelections = watch('itemRestrictions');
    let subheader = 'Loading...';

    if (!isLoading) {
      subheader = getRestrictionSubheader({
        restrictions: itemRestrictionsMeta,
        restrictionFormSelections: itemRestrictionFormSelections,
      });
    }

    return {
      subheader,
    };
  };
